export default __webpack_public_path__ + "static/media/back-to-top-icon.4b616a23.svg";